<template>
    <div class="guide">
        <!-- <img src="../../assets/img/bg.png" alt="" /> -->
        <img src="../../assets/img/logo_t.jpg" alt="" />
        <p style="height:10px;background:#fbfbfb"></p>
        <ul class="guideUl">
            <li>
                <div @click="goToPage('mobilefamily')">
                    <img src="../../assets/img/jzdwbLogoN.jpg" alt="" /> 
                    <p><span>家谱定位表</span></p>
                </div>
            </li>
            <li>
                <div @click="goToPage('mobilelineageChart')">
                    <img src="../../assets/img/jzsxtLogoN.jpg" alt="" /> 
                    <p><span>家族世系图</span></p>
                </div>
            </li>
            <li>
                <div @click="goToPage('mobilescorebook')">
                    <img src="../../assets/img/psLogoN.png" alt="" /> 
                    <p><span>谱书</span></p>
                </div>
            </li>
            <li>
                <div @click="goToPage('mobiledistributed')">
                    <img src="../../assets/img/jzfbtLogoN.jpg" alt="" /> 
                    <p><span>家族分布图</span></p>
                </div>
            </li>
            <li>
                <div @click="goToPage('mobilemigrate')">
                    <img src="../../assets/img/jzqxtLogoN.jpg" alt="" /> 
                    <p><span>家族迁徙图</span></p>
                </div>
            </li>
            <li>
                <div @click="goToPage('mobilefivefu')">
                    <img src="../../assets/img/jzwftLogoN.jpg" alt="" /> 
                    <p><span>九族五服图</span></p>
                </div>
            </li>
            <li>
                <div @click="goToPage('mobilelookfor')">
                    <img src="../../assets/img/yjxzLogoN.png" alt="" /> 
                    <p><span>一键寻祖</span></p>
                </div>
            </li>
            <li>
                <div @click="goToPage('mobilecancestor')">
                    <img src="../../assets/img/czgzLogoN.png" alt="" /> 
                    <p><span>查找共祖</span></p>
                </div>
            </li>
            <li>
                <div @click="goToPage('mobilestatistics')">
                    <img src="../../assets/img/cxhzLogoN.jpg" alt="" /> 
                    <p><span>查询汇总</span></p>
                </div>
            </li>
        </ul>
       <!--  <ul class="">
            <li>
                <router-link to="/mobilefamily" style="position: relative">
                    <div>
                        <img src="../../assets/img/jzdwbLogoN.jpg" alt="" /> 
                    </div>
                    <p><span>家谱定位表</span></p>
                </router-link>
            </li>
            <li>
                <router-link to="/mobilelineageChart">
                    <div>
                        <img src="../../assets/img/jzsxtLogoN.jpg" alt="" /> 
                    </div>
                    <p><span>家族世系图</span></p>

                </router-link>
            </li>
            <li>
                <router-link to="/mobilescorebook">
                    <div>
                        <img src="../../assets/img/psLogoN.png" alt="" /> 
                    </div>
                    <p><span>谱书</span></p>

                </router-link>
            </li>
            <li>
                <router-link to="/mobiledistributed">
                    <div>
                        <img src="../../assets/img/jzfbtLogoN.jpg" alt="" /> 
                    </div>
                    <p><span>家族分布图</span></p>

                </router-link>
            </li>
            <li>
                <router-link to="/mobilemigrate">
                    <div>
                        <img src="../../assets/img/jzqxtLogoN.jpg" alt="" /> 
                    </div>
                    <p><span>家族迁徙图</span></p>

                </router-link>
            </li>
            <li>
                <router-link to="/mobilefivefu">
                    <div>
                        <img src="../../assets/img/jzwftLogoN.jpg" alt="" /> 
                    </div>
                    <p><span>九族五服图</span></p>
                </router-link>
            </li>
            <li>
                <router-link to="/mobilelookfor">
                    <div>
                        <img src="../../assets/img/yjxzLogoN.png" alt="" /> 
                    </div>
                    <p><span>一键寻祖</span></p>

                </router-link>
            </li>
            <li>
                <router-link to="/mobilecancestor">
                    <div>
                        <img src="../../assets/img/czgzLogoN.png" alt="" /> 
                    </div>
                    <p><span>查找共祖</span></p>

                </router-link>
            </li>
            <li>
                <router-link to="/mobilestatistics">
                    <div>
                        <img src="../../assets/img/cxhzLogoN.jpg" alt="" /> 
                    </div>
                        <p><span>查询汇总</span></p>

                </router-link>
            </li>
        </ul> -->
        <p class="logout">
            <a href="javascript:;" @click="handleCommand('login')">退出登录</a>
        </p>
    </div>
</template>

<script>
import api from "@/request/api";
export default {
    data() {
        return {
            flag: "pc"
        };
    },
    mounted() {
        if (this.isMobile()) {
            // 手机端
            sessionStorage.setItem("flag", "app");
            this.flag = "app";
        } else {
            // pc端
            sessionStorage.setItem("flag", "pc");
            this.flag = "pc";
            this.$router.push("/family");
        }
    },
    methods: {
        isMobile() {
            let flag = navigator.userAgent.match(
                /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
            );
            return flag;
        },
        goToPage(type){
            this.$router.push(type);
        },
        handleCommand(command) {
            var that = this;
            if (command == "login") {
                api.logout().then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: "退出成功",
                            type: "success"
                        });
                        setTimeout(function () {
                            that.$router.push("/");
                        }, 2000);
                    }
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.guide {
    width: 100%;
    height: 100%;
    background: #fefefe;
    padding-bottom: 2rem;
    // padding-top:60px;
    > img {
        width: 100%;
    }
    .guideUl{
        padding-left: 5%;
        padding-top:10px;
        li:not(:nth-child(3n)){
            margin-right:4%;
        }
        li{
           display: inline-block;
            width: 28%;
            height: 4.5rem;
            // height: 7.5rem;
            margin-top: 15px;
            position: relative;
            div{
                img{
                    width:100%; 
                    height: 100%; 
                    border-radius: 20px;
                    object-fit: contain; /* 图片将被缩放以适应容器 */
                }
            }
            p{
                text-align: center;
                color: #3c3c3c;
                font-size: 0.8rem;
                padding: 0.3rem 0.3rem;
            }
        }
        
    }
    // ul{
    //     padding-left: 5.5%;
    //      margin-top: 20px;
    //     li:not(:nth-child(3n)){
    //         margin-right: 3.5%;
    //     }
    //     li {
    //         width: 28%;
    //         display: inline-block;
    //         /* padding: 1rem 2rem; */
    //         height: 5rem;
    //         margin-bottom: 2rem;
    //         div{
    //             width:100%;
    //             height:100%;
    //             // background:#ffff01;

    //             position: relative;
    //             // border-radius: 0.6rem;
    //             // border-bottom-left-radius: 0.7rem;
    //             // border-bottom-right-radius: 0.7rem;
    //             // box-shadow: 0.5rem 0.8rem 0.7rem -1.1rem#000;
    //             color:#3c3c3c;
    //             img{
    //                 position: absolute;
    //                 z-index: 999;
    //                 border-radius: 16px;
    //                 // width: 90%;
    //                 width:100%; 
    //                 height: 100%; 
    //                 object-fit: contain; /* 图片将被缩放以适应容器 */
    //                 // margin-left: 5%;
    //                 // right:0.5rem;
    //             }
              
    //         }
    //         p:last-child{
    //                 // position: absolute;
    //                 // bottom: 0;
    //                 width: 100%;
    //                 height: 40%;
    //                 // background: #fff;
    //                 text-align: center;
    //                 color: #3c3c3c;
    //                 font-size: 0.7rem;
    //                 padding: 0.3rem 0.3rem;
    //                 border-bottom-left-radius: 0.6rem;
    //                 border-bottom-right-radius: 0.6rem;
    //             }
    //         img {
    //             width: 100%;
    //         }
    //         // span {
    //         //     position: absolute;
    //         //     bottom: -25px;
    //         //     left: 5px;
    //         //     background: #fff;
    //         //     color: #e68d95;
    //         // }
    //     }
    //     // li:first-child div{
    //     //     background:#ff0202 ;
    //     //   /*   span{
    //     //         color:#ff0202
    //     //     } */
    //     // }
    //     // li:nth-child(2) div{
    //     //     background:#fdc003 ;
    //     //    /*  span{
    //     //         color:#fdc003
    //     //     } */
    //     // }
    //     // li:nth-child(3) div{
    //     //     background:#fed7d7 ;
    //     //     // background:#d0cecf ;
    //     //    /*  span{
    //     //         color:#d0cecf
    //     //     } */
    //     // }
    //     // li:nth-child(4) div{
    //     //     background:#5c9ad5 ;
    //     //     /* span{
    //     //         color:#5c9ad5
    //     //     } */
    //     // }
    //     // li:nth-child(5) div{
    //     //     background:#92d051;
    //     //     /* span{
    //     //         color:#92d051
    //     //     } */
    //     // }
    //     // li:nth-child(6) div{
    //     //     background:#ec7e31 ;
    //     //     /* span{
    //     //         color:#ec7e31
    //     //     } */
    //     // }
    //     // li:nth-child(7) div{
    //     //     background:#ffff01;
    //     //     /* span{
    //     //         color:#ffff01
    //     //     } */
    //     // }
    //     // li:nth-child(8) div{
    //     //     background:#718595 ;
    //     //    /*  span{
    //     //         color:#718595
    //     //     } */
    //     // }
    //     // li:nth-child(9) div{
    //     //     background:#2ef159 ;
    //     //     /* span{
    //     //         color:#2ef159
    //     //     } */
    //     // }
    // }
   
   
    .logout {
        text-align: center;
        background: #fefefe;
        margin-top: 15px;
        a {
            margin: 0 auto;
            font-size: 1.3rem;
            font-weight: bold;
            color: #f74849;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/guide.vue